import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBoxOpen, FaCheckCircle, FaEdit, FaEllipsisH, FaFileInvoice, FaFilePdf, FaFilter, FaInfo, FaMoneyBillWave, FaPlus, FaSearch, FaTrash, FaUpload } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { receiptNoteActions } from '../../sagas/receiptNoteSlice';
import InvoiceForm from './InvoiceForm';
import ReceiptNoteNew from './ReceiptNoteNew';
import { formatPrice } from '../../helpers/utility';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { convertNumberToWords } from '../../helpers/utility';
import { productActions } from '../../sagas/productSlice';

const ReceptionPage = () => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [selectedNote, setSelectedNote] = useState(null);
    const [checkedReceptions, setCheckedReceptions] = useState([]);
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const { company } = useSelector(state => state.auth);
    const { receiptNotes, isLoading } = useSelector((state) => state.receiptNote);
    const { loading } = useSelector((state) => state.invoiceSupplier);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const [filters, setFilters] = useState({
        fournisseurId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unite


    const fileInputRef = useRef(null);

    const searchInputRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(receiptNoteActions.search(payload));
    }, [filters]);

    useEffect(() => {
        dispatch(productActions.findAllUnites());
    }, []);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [receiptNotes]);

    const handleCloseReceiptNoteModal = () => {
        setShowModal(false);
        setSelectedNote(null);
        let payload = {
            ...filters,
        };
        dispatch(receiptNoteActions.search(payload));
    };

    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(receiptNoteActions.search({
                ...filters,
                query: query,
            }));
        }, 1000), // Wait 1000ms after last keystroke
        []
    );

    // Replace the empty handleGeneratePdf function with this implementation
    const handleGeneratePdf = (note, documentType = 'reception', withPrices = true) => {
        // Create a wrapper function for convertNumberToWords to add the currency suffix
        const convertAmountToWords = (amount) => {
            const words = convertNumberToWords(Math.round(amount));
            return `${words} dirhams`;
        };

        // Set colors for reception document
        let primaryColor = [76, 175, 80]; // Green for Reception
        let secondaryColor = [102, 187, 106];
        let documentTitle = `BON DE RÉCEPTION N° ${note.numero}`;

        // Create PDF with slightly larger page format for better layout
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });

        // Set document properties
        doc.setProperties({
            title: documentTitle,
            subject: documentTitle,
            author: 'MatjarPOS',
            creator: 'MatjarPOS System'
        });

        // Get page dimensions
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        const margin = 15;
        const footerHeight = 20;
        const headerHeight = 40;

        // Use actual company data from the Redux store if available
        const companyData = {
            name: company?.name || "Ma Société",
            subtitle: company?.subtitle || "Votre partenaire de confiance",
            address: company?.address || "123 Rue Exemple, Ville",
            phone1: company?.phone1 || "0123456789",
            phone2: company?.phone2 || "0987654321",
            email: company?.email || "contact@masociete.com",
            cnss: company?.cnss || "123456789",
            ice: company?.ice || "123456789",
            rc: company?.rc || "123456789",
            if: company?.identificationFiscale || "123456789",
            logo: company?.logo || null,
            website: company?.website || "www.masociete.com",
        };

        // Function to add header to each page
        const addHeader = (doc, isFirstPage = false) => {
            // Add modern header with gradient
            doc.setFillColor(primaryColor[0], primaryColor[1], primaryColor[2]);
            doc.rect(0, 0, pageWidth, isFirstPage ? headerHeight : 20, 'F');
            doc.setFillColor(secondaryColor[0], secondaryColor[1], secondaryColor[2]);
            doc.rect(0, 0, pageWidth, 5, 'F');

            // Add logo if available and it's the first page
            if (isFirstPage && companyData.logo) {
                try {
                    doc.addImage(companyData.logo, 'JPEG', margin, 10, 40, 20);
                } catch (e) {
                    console.error("Error adding logo to PDF", e);
                }
            }

            // Add company name and subtitle with improved styling
            doc.setTextColor(255, 255, 255);

            if (isFirstPage) {
                doc.setFontSize(22);
                doc.setFont('helvetica', 'bold');
                doc.text(companyData.name, pageWidth / 2, 18, { align: 'center' });
                doc.setFontSize(12);
                doc.setFont('helvetica', 'normal');
                const subtitleMaxWidth = pageWidth - (margin * 2);
                const wrappedSubtitle = doc.splitTextToSize(companyData.subtitle, subtitleMaxWidth);
                doc.text(wrappedSubtitle, pageWidth / 2, 25, { align: 'center' });

                doc.setFontSize(8);
                doc.text(`${companyData.address} | Tél: ${companyData.phone1} | Email: ${companyData.email}`, pageWidth / 2, 35, { align: 'center' });
            } else {
                doc.setFontSize(12);
                doc.setFont('helvetica', 'bold');
                doc.text(`${documentTitle} (Suite)`, pageWidth / 2, 12, { align: 'center' });
            }
        };

        // Function to add footer to each page
        const addFooter = (doc) => {
            doc.setFillColor(primaryColor[0], primaryColor[1], primaryColor[2]);
            doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, 'F');

            doc.setFontSize(9);
            doc.setTextColor(255, 255, 255);
            doc.setFont('helvetica', 'normal');
            doc.text(companyData.name, pageWidth / 2, pageHeight - 14, { align: 'center' });
            doc.setFontSize(7);
            doc.text(`${companyData.address} | Tél: ${companyData.phone1} | Email: ${companyData.email} | ICE: ${companyData.ice}`, pageWidth / 2, pageHeight - 9, { align: 'center' });
            doc.text(`RC: ${companyData.rc} | IF: ${companyData.if} | CNSS: ${companyData.cnss} | ${companyData.website}`, pageWidth / 2, pageHeight - 4, { align: 'center' });

            doc.setFontSize(8);
            doc.setTextColor(255, 255, 255);
            doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth / 2, pageHeight - 20, { align: 'center' });
        };

        // Add first page header
        addHeader(doc, true);

        // Add document title with elegant styling
        doc.setFillColor(240, 240, 240);
        doc.roundedRect(margin, 45, pageWidth - (2 * margin), 12, 2, 2, 'F');
        doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(documentTitle, pageWidth / 2, 53, { align: 'center' });

        // Format date with better styling
        const formattedDate = new Date(note.createdAt).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });

        // Reception Information Card on the left
        doc.setFillColor(248, 249, 250);
        doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 35, 2, 2, 'F');
        doc.setDrawColor(220, 220, 220);
        doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 35, 2, 2, 'S');

        // Reception Information Header
        doc.setFillColor(primaryColor[0], primaryColor[1], primaryColor[2]);
        doc.roundedRect(margin, 65, (pageWidth - (3 * margin)) / 2, 8, 2, 2, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text("INFORMATION RÉCEPTION", margin + ((pageWidth - (3 * margin)) / 4), 70.5, { align: 'center' });

        // Reception Information Content
        doc.setTextColor(60, 60, 60);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');

        let receptionDateText = "Date: ";
        if (note.dateReception) {
            const formattedReceptionDate = new Date(note.dateReception).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            receptionDateText += formattedReceptionDate;
        } else {
            receptionDateText += "À convenir";
        }
        doc.text(receptionDateText, margin + 5, 78);

        const commandeRef = note.commandeNumero || "Non spécifié";
        doc.text(`Bon de commande: ${commandeRef}`, margin + 5, 83);

        const deliveryNoteNb = note.deliveryNoteNb || "Non spécifié";
        doc.text(`N° Bon de livraison: ${deliveryNoteNb}`, margin + 5, 88);

        const statutText = note.statut === 'VALIDE' ? 'Confirmée' : 'En attente';
        doc.text(`Statut: ${statutText}`, margin + 5, 93);

        // Supplier Information Card on the right
        const rightColumnX = margin * 2 + (pageWidth - (3 * margin)) / 2;
        doc.setFillColor(248, 249, 250);
        doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 35, 2, 2, 'F');
        doc.setDrawColor(220, 220, 220);
        doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 35, 2, 2, 'S');

        // Supplier Information Header
        doc.setFillColor(primaryColor[0], primaryColor[1], primaryColor[2]);
        doc.roundedRect(rightColumnX, 65, (pageWidth - (3 * margin)) / 2, 8, 2, 2, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text("FOURNISSEUR", rightColumnX + ((pageWidth - (3 * margin)) / 4), 70.5, { align: 'center' });

        // Supplier Information Content
        doc.setTextColor(60, 60, 60);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text(note.fournisseurNom || "N/A", rightColumnX + 5, 78);
        doc.setFont('helvetica', 'normal');
        doc.text(`Adresse: ${note.fournisseurAdresse || "N/A"}`, rightColumnX + 5, 83);
        doc.text(`Contact: ${note.fournisseurTelephone || "N/A"}`, rightColumnX + 5, 88);
        doc.text(`ICE: ${note.fournisseurIce || "N/A"}`, rightColumnX + 5, 93);

        // Document Information
        doc.setFillColor(248, 249, 250);
        doc.roundedRect(margin, 105, pageWidth - (2 * margin), 20, 2, 2, 'F');
        doc.setDrawColor(220, 220, 220);
        doc.roundedRect(margin, 105, pageWidth - (2 * margin), 20, 2, 2, 'S');

        doc.setFillColor(primaryColor[0], primaryColor[1], primaryColor[2]);
        doc.roundedRect(margin, 105, pageWidth - (2 * margin), 8, 2, 2, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text("INFORMATION DOCUMENT", pageWidth / 2, 110.5, { align: 'center' });

        doc.setTextColor(60, 60, 60);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');

        const col1X = margin + 5;
        const col2X = pageWidth / 2 + 5;

        doc.text(`Numéro: ${note.numero}`, col1X, 118);
        doc.text(`Date: ${formattedDate}`, col2X, 118);

        if (note.commandeNumero) {
            doc.text(`Bon Commande: ${note.commandeNumero}`, col1X, 123);
            if (note.commandeDateCreation) {
                doc.text(`Date Commande: ${note.commandeDateCreation}`, col2X, 123);
            }
        }

        // Start table at a lower Y position
        const tableStartY = 130;

        // Prepare table data
        const tableData = note.lignes?.map((ligne) => {
            if (withPrices) {
                return [
                    ligne.articleCode || 'N/A',
                    ligne.articleNom || 'N/A',
                    ligne.quantiteRecue || 0,
                    ligne.unite || 'U',
                    `${(ligne.prixUnitaireHT || 0).toFixed(2)} DH`,
                    `${((ligne.quantiteRecue || 0) * (ligne.prixUnitaireHT || 0) * (1 + (ligne.tauxTVA || 0))).toFixed(2)} DH`,
                ];
            } else {
                return [
                    ligne.articleCode || 'N/A',
                    ligne.articleNom || 'N/A',
                    ligne.quantiteRecue || 0,
                    ligne.unite || 'U',
                    '',
                    '',
                ];
            }
        }) || [];

        // Define table headers
        const tableHeaders = withPrices
            ? ["Code", "Description", "Qté Reçue", "UM", "PU HT", "Total TTC"]
            : ["Code", "Description", "Qté Reçue", "UM", "", ""];

        // Use autoTable with proper width management
        autoTable(doc, {
            startY: tableStartY,
            head: [tableHeaders],
            body: tableData,
            theme: 'striped',
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
                cellWidth: 'wrap'
            },
            headStyles: {
                fillColor: primaryColor,
                textColor: [255, 255, 255],
                fontStyle: 'bold',
                halign: 'center',
            },
            columnStyles: {
                0: { halign: 'center' },
                1: { halign: 'left' },
                2: { halign: 'center' },
                3: { halign: 'center' },
                4: { halign: withPrices ? 'right' : 'center' },
                5: { halign: withPrices ? 'right' : 'center' },
            },
            margin: { top: tableStartY, right: margin, bottom: footerHeight + 10, left: margin },
            tableWidth: 'auto',
            didDrawPage: (data) => {
                if (data.pageNumber > 1) {
                    addHeader(doc, false);
                }
                addFooter(doc);
            },
        });

        // Get the Y position after the table
        // Get the Y position after the table
        let currentY = doc.lastAutoTable.finalY + 5;

        // Determine if this is a small document (few lines)
        const isSmallDocument = (note.lignes?.length || 0) <= 6;

        // Only show totals if prices are displayed
        if (withPrices) {
            // Calculate total TTC with rounding
            const totalTTC = Math.round(note.montantTotalTTC || 0);

            // Create a modern summary box - simplified to only show Total TTC
            const summaryHeight = isSmallDocument ? 20 : 24;
            doc.setFillColor(248, 249, 250);
            doc.roundedRect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, summaryHeight, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, summaryHeight, 2, 2, 'S');

            // Total row with highlight
            doc.setFillColor(primaryColor[0], primaryColor[1], primaryColor[2]);
            doc.rect(rightColumnX, currentY, (pageWidth - (3 * margin)) / 2, summaryHeight, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.text("TOTAL TTC:", rightColumnX + 5, currentY + (summaryHeight * 0.6));
            doc.text(`${totalTTC} DH`, rightColumnX + (pageWidth - (3 * margin)) / 2 - 5, currentY + (summaryHeight * 0.6), { align: 'right' });

            // Add amount in words with better styling
            const totalInWords = convertAmountToWords(totalTTC);
            const wordsBoxHeight = isSmallDocument ? 25 : 30;
            doc.setFillColor(245, 245, 245);
            doc.roundedRect(margin, currentY, (pageWidth - (3 * margin)) / 2, wordsBoxHeight, 2, 2, 'F');
            doc.setDrawColor(220, 220, 220);
            doc.roundedRect(margin, currentY, (pageWidth - (3 * margin)) / 2, wordsBoxHeight, 2, 2, 'S');

            doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text("Arrêté le présent bon de réception à la somme de:", margin + 5, currentY + 8);
            doc.setTextColor(60, 60, 60);
            doc.setFont('helvetica', 'italic');

            // Split long text into multiple lines if needed
            const maxWidth = (pageWidth - (3 * margin)) / 2 - 10;
            const splitText = doc.splitTextToSize(totalInWords, maxWidth);
            doc.text(splitText, margin + 5, currentY + 16);

            // Update current Y position after the totals section
            currentY += isSmallDocument ? 35 : 40;
        } else {
            // If not showing prices, just add a small space
            currentY += 10;
        }

        // Add terms and conditions - Condensed for small document
        doc.setFontSize(9);
        doc.setTextColor(80, 80, 80);
        doc.setFont('helvetica', 'normal');
        doc.text("Conditions et modalités:", margin, currentY);
        doc.setFontSize(8);

        // Reduced line spacing for small document
        const lineSpacing = isSmallDocument ? 5 : 7;

        // Set terms for reception document
        doc.text("• Les produits ont été vérifiés et sont conformes à la commande.", margin, currentY + lineSpacing);
        doc.text("• Toute réclamation doit être effectuée dans les 48 heures suivant la réception.", margin, currentY + (lineSpacing * 2));
        if (withPrices) {
            doc.text("• Les prix indiqués sont en Dirhams (DH) et incluent la TVA.", margin, currentY + (lineSpacing * 3));
        } else {
            doc.text("• Document non commercial, ne peut servir de facture.", margin, currentY + (lineSpacing * 3));
        }

        // Update current Y position after terms and conditions
        currentY += isSmallDocument ? 20 : 25;

        // Check if we need to add a new page for signature
        const signatureHeight = isSmallDocument ? 35 : 40;

        // Only add a new page if absolutely necessary
        const remainingSpace = pageHeight - footerHeight - currentY;
        if (remainingSpace < signatureHeight) {
            doc.addPage();
            addHeader(doc, false);
            addFooter(doc);
            currentY = 30; // Reset Y position on new page
        }

        // Add signature section
        doc.setDrawColor(200, 200, 200);
        doc.setFontSize(9);
        doc.setTextColor(80, 80, 80);
        doc.setFont('helvetica', 'bold');
        doc.text("Signatures:", margin, currentY);

        // Draw signature boxes
        const signatureBoxHeight = isSmallDocument ? 20 : 25;
        const boxWidth = (pageWidth - (3 * margin)) / 2;

        // Supplier signature box
        doc.rect(margin, currentY + 5, boxWidth, signatureBoxHeight, 'S');
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.setFont('helvetica', 'italic');
        doc.text("Signature Fournisseur", margin + 5, currentY + 8);
        doc.text("Date: ___________________", margin + 5, currentY + 15);
        doc.text("Nom: ___________________", margin + 5, currentY + 22);

        // Company signature box
        doc.rect(rightColumnX, currentY + 5, boxWidth, signatureBoxHeight, 'S');
        doc.text("Signature Société", rightColumnX + 5, currentY + 8);
        doc.text("Date: ___________________", rightColumnX + 5, currentY + 15);
        doc.text("Nom: ___________________", rightColumnX + 5, currentY + 22);

        // Add footer to the first page
        addFooter(doc);

        // Save the PDF with appropriate filename
        let filename = withPrices
            ? `BonReception-${note.numero}.pdf`
            : `BonReception-SansPrix-${note.numero}.pdf`;

        doc.save(filename);
    };


    const getStatusBadge = (status) => {
        switch (status) {
            case 'EN_ATTENTE':
                return <Badge color="secondary">En attente confirmation</Badge>;
            case 'VALIDE':
                return <Badge color="success">Confirmée</Badge>;

            default:
                return <Badge color="light">-</Badge>;
        }
    };

    const handleCheckboxChange = (noteId) => {
        setCheckedReceptions((prevChecked) => {
            if (prevChecked.includes(noteId)) {
                return prevChecked.filter((id) => id !== noteId);
            } else {
                return [...prevChecked, noteId];
            }
        });
    };

    const handleCreateInvoice = () => {
        if (checkedReceptions.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('reception.noReceptionsSelected'),
            });
            return;
        }

        const selectedReceiptNotes = receiptNotes.filter(note =>
            checkedReceptions.includes(note.id)
        );

        // Validation: same supplier + confirmed
        const firstSupplier = selectedReceiptNotes[0].supplierId;
        const allSameSupplier = selectedReceiptNotes.every(n => n.supplierId === firstSupplier);
        const allConfirmed = selectedReceiptNotes.every(n => n.statut === 'VALIDE');

        if (!allSameSupplier) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('reception.noteFromifferentSuppliers'),
            });
            return;
        }

        if (!allConfirmed) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('reception.notAllConfirmed'),
            });
            return;
        }

        const lineMap = {};

        selectedReceiptNotes.forEach(note => {
            note.lignes.forEach(line => {

                const key = line.articleId;
                const tva = line.tauxTVA; // <-- TVA already ratio (e.g. 0.2)

                if (!lineMap[key]) {
                    lineMap[key] = {
                        articleId: line.articleId,
                        articleNom: line.articleNom,
                        unite: unites.find(u => u.code === line.unite)?.libelle,
                        prixUnitaireHT: line.prixUnitaireHT,
                        prixUnitaireTTC: line.prixUnitaireTTC,
                        tauxTVA: tva,
                        quantite: 0,
                        montantHT: 0,
                        montantTVA: 0,
                        montantTTC: 0
                    };
                }

                // Increment quantities and totals
                lineMap[key].quantite += line.quantiteRecue;
                lineMap[key].montantHT += line.montantHT;
                lineMap[key].montantTTC += line.montantTTC;
                lineMap[key].montantTVA += (line.montantTTC - line.montantHT);
            });
        });

        const aggregatedLines = Object.values(lineMap);

        // ------------------------------------------
        // Global Totals
        // ------------------------------------------
        const montantHT = aggregatedLines.reduce((s, l) => s + l.montantHT, 0);
        const montantTVA = aggregatedLines.reduce((s, l) => s + l.montantTVA, 0);
        const montantTTC = aggregatedLines.reduce((s, l) => s + l.montantTTC, 0);

        // ------------------------------------------
        // Receipt -> Invoice mapping
        // ------------------------------------------
        const receiptMappings = selectedReceiptNotes.map(note => ({
            id: note.id,
            numero: note.numero,
            dateReception: note.dateReception,
            montantTTC: note.lignes.reduce(
                (tot, line) => tot + line.montantTTC,
                0
            )
        }));

        // ------------------------------------------
        // Build final invoice object
        // ------------------------------------------
        const newInvoice = {
            dateFacture: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
            dateOperation: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
            fournisseurId: selectedReceiptNotes[0].fournisseurId,
            fournisseurNom: selectedReceiptNotes[0].fournisseurNom,
            numeroFactfournisseur: '',
            statut: "IMPAYE",
            receiptMappings,
            lignes: aggregatedLines,
            montantHT,
            montantTVA,
            montantTTC
        };

        setInvoice(newInvoice);
        setShowInvoiceModal(true);
    };


    const handleCloseInvoiceModal = () => {
        setShowInvoiceModal(false);
        setInvoice(null);
        setCheckedReceptions([]); // Clear checked receptions after closing the invoice modal
        let payload = {
            ...filters
        };
        dispatch(receiptNoteActions.search(payload));

    };

    if (isLoading || loading) {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}
            >
                <Spinner color="primary" />
            </div>
        );
    }

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleValidate = (receiptNote) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('reception.confirmValidateMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('reception.confirmValidate'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                if (receiptNote.id > 0) {
                    dispatch(receiptNoteActions.validateReceiptNote({
                        id: receiptNote.id,
                        onSuccess: () => {
                            Swal.fire(
                                t('common.saved'),
                                t('reception.savedSuccess'),
                                'success'
                            );
                            refreshReceiptNotes();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    }));
                }
            }
        });
    };

    const refreshReceiptNotes = () => {
        let payload = {
            ...filters
        };
        dispatch(receiptNoteActions.search(payload));
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            fournisseurId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel'
            ];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    icon: 'error',
                    title: t('product.invalidFileType'),
                    text: t('product.excelOnly'),
                });
                return;
            }

            try {
                const formData = new FormData();
                formData.append('file', file);

                let payload = {
                    formData: formData,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: t('delivery.uploadSuccess'),
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#198754'
                        });
                        refreshReceiptNotes();
                    },
                }
                dispatch(receiptNoteActions.uploadRCs(payload));

            } catch (error) {
                console.error('Error parsing Excel:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur!',
                    text: "Erreur lors de l'importation des produits",
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#dc3545'
                });
            } finally {
                // Reset file input
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        }
    };

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaBoxOpen className="text-primary me-2" />
                                {t('reception.title')}
                            </h4>
                            <div className="d-flex align-items-center gap-2">
                                <Button color="primary" onClick={() => fileInputRef.current.click()}>
                                    <FaUpload className="me-2" /> {t('reception.importer')}
                                </Button>
                                {/* Primary actions */}
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="me-2" /> {t('reception.newReception')}
                                </Button>
                                {checkedReceptions.length > 0 && (
                                    <Button color="success" onClick={handleCreateInvoice}>
                                        <FaFileInvoice className="me-2" />
                                        {t('reception.createInvoice')}
                                    </Button>
                                )}
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleFileUpload}
                                    accept=".xlsx,.xls"
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={7} md={4} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('reception.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                        debouncedSearch(value);
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>

                            <table className="table table-hover table-striped table-bordered" style={{ fontSize: '0.8rem' }}>
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center"></th>
                                        <th className="align-middle text-center">{t('reception.receiptNumber')}</th>
                                        <th className="align-middle text-center">{t('purchase.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('purchase.dateModification')}</th>
                                        <th className="align-middle text-center">{t('reception.receiptDate')}</th>
                                        <th className="align-middle text-center">{t('reception.supplier')}</th>
                                        <th className="align-middle text-center">{t('reception.entrepot')}</th>
                                        <th className="align-middle text-center">{t('reception.totalTtc')}</th>
                                        <th className="align-middle text-center">{t('reception.totalHt')}</th>
                                        <th className="align-middle text-center">{t('reglement.montantPaye')}</th>
                                        <th className="align-middle text-center">{t('delivery.regle')}</th>
                                        <th className="align-middle text-center">{t('delivery.facture')}</th>
                                        <th className="align-middle text-center">{t('reception.status')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {receiptNotes?.map((note) => (
                                        <tr key={note.id}>
                                            <td className="align-middle text-center">
                                                {note.statut === 'VALIDE' && !note.facture && (
                                                    <Input
                                                        type="checkbox"
                                                        checked={checkedReceptions.includes(note.id)}
                                                        onChange={() => handleCheckboxChange(note.id)}
                                                    />
                                                )}
                                            </td>
                                            <td className="align-middle text-center">{note.numero}</td>
                                            <td className="align-middle text-center">{note.createdAt}</td>
                                            <td className="align-middle text-center">{note.updatedAt}</td>
                                            <td className="align-middle text-center">{note?.dateReception}</td>
                                            <td className="align-middle text-center">{note.fournisseurNom}</td>
                                            <td className="align-middle text-center">{note.entrepotNom}</td>
                                            <td className="align-middle text-center">{formatPrice(note.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(note.montantTotalHT, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(note.montantRegle, false)}</td>
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={note.estRegle}
                                                    readOnly
                                                />
                                            </td>
                                            {/* Add facture status column */}
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={note.facture}
                                                    readOnly
                                                />
                                            </td>
                                            <td className="align-middle text-center">
                                                {getStatusBadge(note.statut)}
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {note.statut === 'EN_ATTENTE' && <Button
                                                        color="success"
                                                        title={t('devis.devisValide')}
                                                        onClick={() => handleValidate(note)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}

                                                    <UncontrolledDropdown>
                                                        <DropdownToggle caret color="secondary" size="sm" className='me-1'>
                                                            <FaFilePdf />
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem onClick={() => handleGeneratePdf(note, 'reception', true)}>
                                                                {t('reception.pdfWithPrices')}
                                                            </DropdownItem>
                                                            <DropdownItem onClick={() => handleGeneratePdf(note, 'reception', false)}>
                                                                {t('reception.pdfWithoutPrices')}
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>

                                                    <Button color="warning" title='Consulter' onClick={() => {
                                                        setSelectedNote(note);
                                                        setShowModal(true);
                                                    }} size="sm" className="px-2 py-1">
                                                        <FaEdit size={12} className="mr-2" />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {receiptNotes.length === 0 && (
                                        <tr>
                                            <td colSpan="14" className="text-center py-4">
                                                <div className="text-muted">{t('reception.noRC')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="7" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(receiptNotes.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(receiptNotes.reduce((sum, bl) => sum + (bl.montantTotalHT || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(receiptNotes.reduce((sum, bl) => sum + (bl.montantRegle || 0), 0), false)}</td>
                                        <td colSpan="3"></td>
                                    </tr>
                                </tfoot>

                            </table>
                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseReceiptNoteModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseReceiptNoteModal}>
                    {t('reception.new')}  {selectedNote ? `- ${selectedNote?.numero}` : ''}
                </ModalHeader>
                <ModalBody>


                    {showModal && (
                        <ReceiptNoteNew onClose={handleCloseReceiptNoteModal} reception={selectedNote} />
                    )}
                </ModalBody>
            </Modal>
            <Modal isOpen={showInvoiceModal} toggle={handleCloseInvoiceModal} size="xl">
                <ModalHeader toggle={handleCloseInvoiceModal}>
                    {t('facture.newInvoice')}
                </ModalHeader>
                <ModalBody>
                    {invoice && (
                        <InvoiceForm
                            initialValues={invoice}
                            onClose={handleCloseInvoiceModal}
                        />
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
}

export default ReceptionPage;